import { render, staticRenderFns } from "./adminMobileTransfer.vue?vue&type=template&id=93757962&scoped=true&"
import script from "./adminMobileTransfer.vue?vue&type=script&lang=js&"
export * from "./adminMobileTransfer.vue?vue&type=script&lang=js&"
import style0 from "./adminMobileTransfer.vue?vue&type=style&index=0&id=93757962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93757962",
  null
  
)

export default component.exports